export const CelescLogos = () => (
  <div>
    <img
      src="https://storage.googleapis.com/mk-move-repository/white-label/celesc/images/dash-logo2.png"
      className="celesc-logo2-auth"
    />

    <img
      src="https://storage.googleapis.com/mk-move-repository/white-label/celesc/images/dash-logo3.png"
      className="celesc-logo3-auth"
    />
  </div>
);
